import { Provider } from '@angular/core';
import { environment } from '@env/environment';
import { FORMS_SECURE_UPLOAD_URL } from './forms-secure-upload-config.token';

export function provideFormsSecureUploadUrl(): Provider[] {
  return [
    {
      provide: FORMS_SECURE_UPLOAD_URL,
      useValue: environment.formsSecureUploadUrl,
    },
  ];
}
